<div class="login-wrapper d-flex align-items-center justify-content-center">
  <div class="auth-img">
    <img src="assets/images/login.png" alt="" class="he" />
  </div>
  <div class="auth-login">
    <ng-container *ngIf="otpSent == false; else otpSentBlock">
      <div class="text-center my-5">
        <a class="logo" routerLink="/">
          <img src="assets/images/logo.svg" alt="" />
        </a>
      </div>
      <div class="log-title">
        <h1>Reset Password</h1>
        <p>
          Fermentum lacus, porttitor tristique lobortis faucibus sit. Mi, et,
          urna et amet auctor. nunc in nunc neque in et egestas.
        </p>
      </div>

      <form [formGroup]="resetPwdForm">
        <div class="auth-form">
          <div class="f-group">
            <input
              type="text"
              class="form-control"
              placeholder="Enter your Email address"
              formControlName="email"
              [class.is-invalid]="!Global.isInputValid(resetPwdForm, 'email')"
            />

            <div
              class="invalid-feedback"
              *ngIf="
                !Global.isInputRuleValid(resetPwdForm, 'email', 'required')
              "
            >
              <div>This field is required</div>
            </div>
          </div>

          <div class="f-group">
            <button mat-button type="submit" (click)="sendOtp($event)">
              <span class="indicator-label">Send OTP</span>
              <span class="indicator-progress"
                >sending...
                <span
                  class="spinner-border spinner-border-sm align-middle ms-2"
                ></span>
              </span>
            </button>
          </div>

          <div class="f-group text-center mt-4">
            <p>
              <a routerLink="/login" [queryParams]="{ tab: queryParams }"
                ><i class="fas fa-long-arrow-alt-left"></i> Back to Login</a
              >
            </p>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-template #otpSentBlock>
      <ng-container *ngIf="otpValidated == false; else resetPwdBlock">
        <app-otp-verification
          [verificationType]="'forgotpassword'"
          [queryParams]="queryParams"
          [emailToVerify]="this.resetPwdForm.get('email')?.value"
          (onVerificationAction)="otpVerificationAction($event)"
        >
        </app-otp-verification>
      </ng-container>

      <ng-template #resetPwdBlock>
        <div class="text-center my-5">
          <a class="logo" routerLink="/">
            <img src="assets/images/logo.svg" alt="" />
          </a>
        </div>
        <div class="log-title">
          <h1>Change Password</h1>
          <p>
            Fermentum lacus, porttitor tristique lobortis faucibus sit. Mi, et,
            urna et amet auctor. nunc in nunc neque in et egestas.
          </p>
        </div>

        <form [formGroup]="passwordForm">
          <div class="auth-form">
            <div class="f-group">
              <input
                type="text"
                class="form-control"
                [value]="resetPwdForm.get('email')?.value"
                disabled
              />
            </div>

            <div class="f-group">
              <input
                type="password"
                class="form-control"
                placeholder="Password"
                formControlName="password"
                [class.is-invalid]="
                  !Global.isInputValid(passwordForm, 'password')
                "
                autocomplete="new-password"
              />

              <div
                class="invalid-feedback"
                *ngIf="
                  !Global.isInputRuleValid(passwordForm, 'password', 'required')
                "
              >
                <div>This field is required</div>
              </div>

              <div
                class="invalid-feedback"
                *ngIf="
                  !Global.isInputRuleValid(
                    passwordForm,
                    'password',
                    'minlength'
                  )
                "
              >
                <div>The password should be minimum 8 characters</div>
              </div>

              <div
                class="invalid-feedback"
                *ngIf="
                  !Global.isInputRuleValid(
                    passwordForm,
                    'password',
                    'maxlength'
                  )
                "
              >
                <div>The password should be maximum 20 characters</div>
              </div>
              <div
                class="invalid-feedback"
                *ngIf="
                  !Global.isInputRuleValid(passwordForm, 'password', 'pattern')
                "
              >
                <div>
                  The password must include Upper Case, Lower Case, Number,
                  Symbol
                </div>
              </div>
            </div>

            <div class="f-group">
              <input
                type="password"
                class="form-control"
                placeholder="Password Confirmation"
                formControlName="password_confirmation"
                [class.is-invalid]="
                  !Global.isInputValid(passwordForm, 'password_confirmation')
                "
              />

              <div
                class="invalid-feedback"
                *ngIf="
                  !Global.isInputRuleValid(
                    passwordForm,
                    'password_confirmation',
                    'required'
                  )
                "
              >
                <div>This field is required</div>
              </div>

              <div
                class="invalid-feedback"
                *ngIf="
                  !Global.isInputRuleValid(
                    passwordForm,
                    'password_confirmation',
                    'minlength'
                  )
                "
              >
                <div>The password should be minimum 8 characters</div>
              </div>

              <div
                class="invalid-feedback"
                *ngIf="
                  !Global.isInputRuleValid(
                    passwordForm,
                    'password_confirmation',
                    'maxlength'
                  )
                "
              >
                <div>The password should be maximum 20 characters</div>
              </div>
              <div
                class="invalid-feedback"
                *ngIf="
                  !Global.isInputRuleValid(
                    passwordForm,
                    'password_confirmation',
                    'pattern'
                  )
                "
              >
                <div>
                  The confirm password must include Upper Case, Lower Case,
                  Number, Symbol
                </div>
              </div>
            </div>

            <div class="f-group">
              <button mat-button type="submit" (click)="changePassword($event)">
                <span class="indicator-label">Change Password</span>
                <span class="indicator-progress"
                  >Please wait...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span>
                </span>
              </button>
            </div>
          </div>
        </form>
      </ng-template>
    </ng-template>

    <div class="login-footer d-flex align-items-center">
      <p>
        <a target="_blank" routerLink="/privacy-and-policy">Privacy Policy</a>
        <a target="_blank" routerLink="/terms-and-condition"
          >Terms & Conditions</a
        >
      </p>
      <p class="ms-auto">
        <a routerLink="/">{{ Global.APP_NAME }}</a>
        {{ Global.CURRENT_YEAR }} | All Rights Reserved
      </p>
    </div>
  </div>
</div>
